export default "__VITE_ASSET__BLkgHbGg__"